import styles from './bimLoadingSkeleton.module.scss';

export const BimLoadingSkeleton = () => (
  <div
    className={styles.bimLoadingSkeleton}
    data-testid='bim-loading-skeleton'
    aria-busy='true'
    aria-label='Loading project BIM data'
  >
    <div className={styles.lastUpdate} aria-hidden='true' />
    <div className={styles.cards}>
      {Array.from({ length: 2 }, (_, index) => (
        <div key={`large-${index}`} className={styles.largeCard} data-testid='bim-card-skeleton' aria-hidden='true'>
          <span className={styles.icon} />
          <span className={styles.label} />
          <span className={styles.value} />
          <span className={styles.footer} />
        </div>
      ))}
      <div className={styles.rightCards}>
        <div className={styles.cardRow}>
          {Array.from({ length: 2 }, (_, index) => (
            <div key={`upper-${index}`} className={styles.card} data-testid='bim-card-skeleton' aria-hidden='true'>
              <span className={styles.icon} />
              <span className={styles.label} />
              <span className={styles.value} />
            </div>
          ))}
        </div>
        <div className={styles.cardRow}>
          {Array.from({ length: 3 }, (_, index) => (
            <div key={`lower-${index}`} className={styles.card} data-testid='bim-card-skeleton' aria-hidden='true'>
              <span className={styles.label} />
              <span className={styles.value} />
              <span className={styles.bar} />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);
